import {
  ensureDisplayImageUrls,
  pickImageSignOptions,
  sanitizeManagedDisplayResult,
} from '@/utils/imageDisplayAccess';
import { resolveFetchableImageUrl, resolveItemPreviewUrl } from '@/utils/imageUrlUtils';

function isDirectStudioPreviewUrl(raw) {
  const s = String(raw || '').trim();
  return s.startsWith('data:')
    || s.startsWith('blob:')
    || s.startsWith('/images/')
    || s.startsWith('/assets/');
}

/** 智能工具页展示用：优先 viewUrl，受管存储不回退裸 canonical */
export async function resolveStudioPreviewUrl(rawUrl, item = null) {
  const trimmed = String(rawUrl || '').trim();
  if (!trimmed || isDirectStudioPreviewUrl(trimmed)) return trimmed;
  const options = item ? pickImageSignOptions(item) : {};
  const resolved = item
    ? await resolveItemPreviewUrl(trimmed, item)
    : await resolveFetchableImageUrl(trimmed, options);
  return sanitizeManagedDisplayResult(resolved, trimmed);
}

/** 生成结果 / 历史列表：批量 sign-batch 预热缓存 */
export async function prefetchStudioDisplayUrls(urls) {
  const list = [...new Set(
    (Array.isArray(urls) ? urls : [])
      .map((u) => String(u || '').trim())
      .filter((u) => u && !isDirectStudioPreviewUrl(u)),
  )];
  if (!list.length) return;
  await ensureDisplayImageUrls(list);
}

/** 从图片空间/素材记录映射工作室原图项，保留已签名 viewUrl 减少读图 429 */
export function mapStudioLocalSourceFromRecord(record, { id, name } = {}) {
  const rid = String(id || record?.id || '').trim();
  const url = String(record?.url || record?.src || record?.dataUrl || '').trim();
  const view = String(
    record?.viewUrl
    || record?.displayUrl
    || record?.storedViewUrl
    || record?.urlDisplay
    || record?.previewUrl
    || '',
  ).trim();
  return {
    id: rid,
    name: String(name || record?.name || record?.title || rid),
    url,
    ...(view ? { previewUrl: view, viewUrl: view, displayUrl: view } : {}),
  };
}
